<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isCharSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{charSidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isCharSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">
      <div class="pl-6 pr-6 pb-6">
        <!--NAME-->
        <div>
          <label>Name</label>
          <vs-input autocomplete="off" v-validate="'required'" name="Name" v-model="charFormData.name" class="w-full" />
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
        </div>

        <div class="pt-4 pb-6" >
          <label>Description</label>
          <vs-input autocomplete="off" name="Description" v-model="charFormData.description" class="w-full" />
        </div>

        <div class="pt-6">
          <vs-button class="w-full cursor-pointer" color="warning" type="border" icon-pack="feather" icon="icon-settings" @click="showHideCard" v-show="charFormData.id" v-scroll-to="'#charlook'" >Manage Looks</vs-button>
        </div>

      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="addEditCharacter" :disabled="isDisabled" ref="addupdateButton">{{buttoncaption}}</vs-button>
      <!-- <vs-button color="danger" class="mr-4 cursor-pointer" v-show="charFormData.id" @click="deleteCharacter">Delete</vs-button> -->
      <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" v-show="charFormData.id" @click="openConfirm()" ref="deleteButton">Delete</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isCharSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    isCharSidebarActive: {
      type: Boolean,
      required: true
    },
    selectedCharacter: {
      type: Object,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    charSidebarHeader: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      backgroundLoading:'#fff',
      charFormData: {
        id: 0,
        name: "",
        description: ""
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    isCharSidebarActiveLocal: {
      get() {
        return this.isCharSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
    isDisabled: function(){
     return !this.charFormData.name;
    }
  },
  watch: {
    isCharSidebarActive: function(val) {
      if(val){
        if(this.selectedCharacter.id)
        {
          this.charFormData.id = this.selectedCharacter.id;
          this.charFormData.name = this.selectedCharacter.name;
          this.charFormData.description = this.selectedCharacter.description;
        } else {
          this.initValues();
        }
      }
    }
  },
  methods: {
    initValues() {
      this.charFormData.id = 0;
      this.charFormData.name = "";
      this.charFormData.description = "";
      this.errors.clear();
    },
    saveData(){
     this.$emit('saveCharData');
     this.$vs.loading.close(this.$refs.addupdateButton.$el);
     this.$vs.loading.close(this.$refs.deleteButton.$el);
    },
    showHideCard(){
      this.$emit('showHideCard')
    },
    addEditCharacter() {
      this.$validator.validateAll().then(result => {
        var self = this;
        if (result) {
          self.showLoadingOnAddUpdateButton();

          var onSuccess = response => {
            self.saveData();
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: "Character Saved",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });
          };
          var onFinally = function (){
            self.$vs.loading.close(self.$refs.addupdateButton.$el);
          };

          self.$ajaxPost(self, "character/addeditcharacter", self.charFormData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title:'Attention',
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info'
          });
        }
      });
    },
    deleteCharacter() {
      var self = this;
      this.showLoadingOnDeleteButton()

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title: 'Information',
          color: "success",
          text: "Character Deleted",
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-trash',
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
      };
      self.$ajaxDelete(self, "character/removecharacter/" + self.charFormData.id, onSuccess, onFinally);
    },
    showLoadingOnAddUpdateButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addupdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnDeleteButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    openConfirm() {
      this.$emit("closeSidebar");
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Attention`,
        text: 'Are you sure you want to delete the selected character and ALL of its looks?',
        accept: this.deleteCharacter
      })
    },
  },

  components: {
    VuePerfectScrollbar
  }
};
</script>




<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background

  {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
    .img-upload

  {
    margin-top: 2rem;
    .con-img-upload

  {
    padding: 0;
  }

  .con-input-upload {
    width: 100%;
    margin: 0;
  }

  }
  }
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
